import React, { useMemo } from "react";
import { createFilteredAndSortedOptions } from "../../util/dealingArrObj";

export default function DropdownHierarchyTwo({
  settingData,
  handleDropdownChange,
  schoolYear,
  hierarchyOneId,
  hierarchyTwoId,
  parentId = true,
  hierarchyTwoTitle = "학년",
  extraOption = false,
  extraOptionTitle = "",
  required = false,
  disabled = false,
}) {
  const options = useMemo(() => {
    const filters = {
      hierarchy_level: 2,
      school_year: schoolYear,
      ...(parentId && { parent_id: hierarchyOneId }), // 조건부 스프레드
    };

    const sortKey = parentId ? "order" : "group_name";

    return createFilteredAndSortedOptions({
      arrayData: settingData,
      displayKey: "group_name",
      valueKey: "id",
      filters,
      idKey: "id",
      sortKey,
      isDesc: false,
      dataName: "organization_path",
    });
  }, [schoolYear, parentId, hierarchyOneId, settingData]);

  return (
    <select
      className="form-control"
      name="2"
      onChange={handleDropdownChange}
      value={hierarchyTwoId || ""}
      required={required}
      disabled={disabled}
    >
      {extraOption && <option value="">{extraOptionTitle}</option>}
      <option value="0">{hierarchyTwoTitle}</option>
      {settingData?.length > 0 && options}
    </select>
  );
}
